/*
 *    Copyright (c) 2018-2025, fwpt All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: fwpt
 */
import { mapState } from 'vuex'
import XEUtils from 'xe-utils'
import request from "@/router/axios";
import context from "../../../main"
let modules = {};
export function initVxeTable(tableOption) {
  const option = {
    resizable: true,
    showOverflow: true,
    border: 'inner',
    height: document.documentElement.clientHeight-77,
    rowId: 'id',
    printConfig: {
    },
    sortConfig: {
      trigger: 'cell',
      remote: true,
      defaultSort: {
      }
    },
    filterConfig: {
      remote: true
    },
    pagerConfig: {
      pageSize: 100,
      pageSizes: [ 100, 200, 500, 1000]
    },
    exportConfig: {
      // 默认选中类型
      type: 'xlsx',
      // 局部自定义类型
      types: ['xlsx', 'csv', 'html', 'xml', 'txt'],
      // 自定义数据量列表
      modes: ['current', 'all']
    },
    radioConfig: {
      labelField: 'id',
      reserve: true,
      highlight: true
    },
    checkboxConfig:{
      checkStrictly: true,
      showHeader: true,
      trigger: 'row',
      // labelField: 'id',
      reserve: true
    },
    rowConfig: {
      keyField: 'id'
    },
    proxyConfig: {
      seq: true, // 启用动态序号代理
      sort: true, // 启用排序代理
      filter: true, // 启用筛选代理
      props: {
        result: 'result', // 配置响应结果列表字段
        total: 'page.total' // 配置响应结果总页数字段
      },
      ajax: {
        // 接收 Promise 对象
        query: ({page, sorts, filters}) => {
          const queryParams = Object.assign({}, tableOption.param)
          // queryParams.size = page.pageSize;
          // queryParams.current = page.currentPage
          // 处理排序条件
          if(sorts!=null){
            const firstSort = sorts[0]
            if (firstSort) {
              queryParams.sort = firstSort.property
              queryParams.order = firstSort.order
            }
          }

          // 处理筛选条件
          filters.forEach(({property, values}) => {
            queryParams[property] = values.join(',')
          })
          return new Promise(resolve => {
            resolve({
              result: tableOption.fakeData.list,
              page: {
                total: tableOption.fakeData.total
              }
            })
          })

        },
        // 被某些特殊功能所触发，例如：导出数据 mode=all 时，会触发该方法并对返回的数据进行导出
        queryAll: () => fetch(`${this.serveApiUrl}/api/pub/all`).then(response => response.json())


      }

    },
    toolbarConfig: {
      // export: true,
      // print: true,
      className :'toolSet',
      custom: {
        icon: 'el-icon-s-tools'
      },
      export: tableOption.export || false,
      // slots: {
      //   buttons: 'toolbar_buttons'
      // }
    },
    columns: tableOption.columns
  }
  return option;
}

modules = {
  'initVxeTable': initVxeTable,
}
